import React from 'react';
import cx from 'classnames';
import { SLDSAlert, AlertContainer } from '@salesforce/design-system-react';
import Icon from '../Icon/index.js';

const sldsVariants = ["info", "error", "offline", "warning"];
const Alert = ({
  className,
  variant,
  icon,
  skipContainer,
  ...rest
}) => {
  let iconNode;
  if (icon) {
    iconNode = {
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: icon
      })
    };
  }
  let alert = /*#__PURE__*/React.createElement(SLDSAlert, Object.assign({
    className: cx("tds-notify_alert", {
      [`tds-theme_${variant}`]: variant && !sldsVariants.includes(variant)
    }, className),
    variant: sldsVariants.includes(variant) ? variant : "info"
  }, rest, iconNode));
  if (!skipContainer) {
    alert = /*#__PURE__*/React.createElement(AlertContainer, null, alert);
  }
  return alert;
};
Alert.propTypes = SLDSAlert.propTypes;
Alert.defaultProps = SLDSAlert.defaultProps;
var Alert$1 = Alert;

export { Alert$1 as default };
